import React, { useState, useEffect } from 'react';
import SunIcon from '../shared/SunIcon';
import MoonIcon from '../shared/MoonIcon';

const ModeToggle = ({ onModeToggle }) => {
  const [checked, setChecked] = useState(false);

  const modeToggleWrapper = (darkModeEnabled) => {
    onModeToggle(darkModeEnabled);
    setChecked(darkModeEnabled);
  }

  /**
   * Try and see if we have a mode toggle value
   * saved from our local state.
   */
  useEffect(() => {
    const darkModeEnabled = localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);
    modeToggleWrapper(darkModeEnabled);
  });

  return (
    <div className="flex align-center items-center">
      <div className="inline-block mr-2">
        <SunIcon />
      </div>
      <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
        <input
          type="checkbox"
          name="toggle"
          id="toggle"
          checked={checked}
          className="toggle-checkbox absolute inlin-block w-6 h-6 rounded-full bg-white outline-none appearance-none cursor-pointer shadow-md"
          onChange={(e) => modeToggleWrapper(e.target.checked)}
        />
        <label
          htmlFor="toggle"
          className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
        />
      </div>
      <div className="inline-block">
        <MoonIcon />
      </div>
    </div>
  );
}

export default ModeToggle;
